import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AcademicCapIcon, ArrowRightIcon, HeartIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function DashboardSavedCourses({ wishlist, formatDate, onRemove }) {
  const [showAll, setShowAll] = useState(false);
  const visibleCourses = showAll ? wishlist : wishlist.slice(0, 3);

  return (
    <section className="learner-panel" aria-labelledby="learner-saved-title">
      <header className="learner-panel-heading"><h2 id="learner-saved-title">Saved courses</h2></header>
      {wishlist.length ? (
        <div className="learner-saved-list">
          {visibleCourses.map(item => (
            <article className="learner-saved-row" key={item.id}>
              <div className="learner-course-symbol learner-course-symbol--saved" aria-hidden="true"><AcademicCapIcon /></div>
              <div className="learner-saved-copy">
                <h3><Link to={`/courses/${item.course?.id}`}>{item.course?.programme_name}</Link></h3>
                <p>{item.course?.campus?.name || 'Campus pending'}</p>
                {item.added_date || item.created_at ? <p>Saved {formatDate(item.added_date || item.created_at)}</p> : null}
                <Link className="learner-text-link" to={`/courses/${item.course?.id}`}>View course <ArrowRightIcon aria-hidden="true" /></Link>
              </div>
              <button type="button" className="learner-remove-button" onClick={() => onRemove(item.id)}
                aria-label={`Remove ${item.course?.programme_name} from saved courses`}><XMarkIcon aria-hidden="true" /></button>
            </article>
          ))}
          {wishlist.length > 3 ? <button type="button" className="learner-list-toggle" aria-expanded={showAll} onClick={() => setShowAll(value => !value)}>
            {showAll ? 'Show fewer saved courses' : `Show all ${wishlist.length} saved courses`}
          </button> : null}
        </div>
      ) : (
        <div className="learner-empty-state learner-empty-state--compact">
          <HeartIcon aria-hidden="true" /><p>Save courses to explore them later.</p>
          <Link to="/courses" className="learner-text-link">Find a course <ArrowRightIcon aria-hidden="true" /></Link>
        </div>
      )}
    </section>
  );
}
